import React, { useState, useEffect } from "react";
import { fetchUsersByRole } from "../../../api";
import { USER_ROLES } from "../../constants";
import { FaUserFriends } from "react-icons/fa";
import { IoSearchOutline } from "react-icons/io5";
import "../PatientsList/PatientsList.css";

const AdminList = ({ selectedAdminId, onAdminClick }) => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchInput, setSearchInput] = useState("");

  const loadAdmins = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetchUsersByRole(USER_ROLES.ADMIN);
      // Handle different response structures
      const adminsList = Array.isArray(response) 
        ? response 
        : (response?.users || response?.data || []);
      setAdmins(adminsList);
    } catch (error) {
      console.error("Error loading admins:", error);
      setError("Failed to load admins");
      setAdmins([]); // Ensure admins is always an array
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAdmins();
  }, []);

  const handleAdminClick = (admin) => {
    if (onAdminClick) {
      onAdminClick(admin);
    }
  };

  const getAllAdmins = () => {
    return admins || [];
  };

  const getFilteredAdmins = () => {
    let filteredAdmins = getAllAdmins();

    if (searchInput) {
      filteredAdmins = filteredAdmins.filter(
        (admin) =>
          admin.full_name
            ?.toLowerCase()
            .includes(searchInput.toLowerCase()) ||
          admin.email?.toLowerCase().includes(searchInput.toLowerCase()) ||
          admin.username?.toLowerCase().includes(searchInput.toLowerCase())
      );
    }

    return filteredAdmins;
  };

  const getFilteredCounts = () => {
    const allAdmins = admins || [];

    const filteredAll = searchInput
      ? allAdmins.filter(
          (admin) =>
            admin.full_name
              ?.toLowerCase()
              .includes(searchInput.toLowerCase()) ||
            admin.email?.toLowerCase().includes(searchInput.toLowerCase()) ||
            admin.username?.toLowerCase().includes(searchInput.toLowerCase())
        )
      : allAdmins;

    return {
      total: filteredAll.length,
      active: 0,
      inactive: 0,
    };
  };



  if (loading) {
    return (
      <div className="patients-container">
        <div className="loading-message">Loading Admins...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="patients-container">
        <div className="error-message">
          <p>{error}</p>
          <button onClick={loadAdmins}>Retry</button>
        </div>
      </div>
    );
  }

  const filteredAdmins = getFilteredAdmins();
  const filteredCounts = getFilteredCounts();

  return (
    <div className="patients-container">
      <div className="stats-row">
        <div className="stat-card">
          <div className="stat-icon-wrapper first">
            <FaUserFriends className="stat-icon" />
          </div>
          <div className="stat-content">
            <span className="stat-label">
              Total Admins {searchInput && "(filtered)"}
            </span>
            <span className="stat-value">{filteredCounts.total}</span>
          </div>
        </div>
      </div>

      <div className="patients-table-container">
        <div className="table-header">
          <div className="table-controls">
            <div className="search-container">
              <IoSearchOutline className="search-icon" />
              <input
                placeholder="Search Admins..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="search-input"
              />
            </div>
          </div>
        </div>

        <div className="patients-table">
          <div className="table-header-row three-columns">
            <span className="header-cell">Name</span>
            <span className="header-cell">Email</span>
            <span className="header-cell">Actions</span>
          </div>

          {filteredAdmins.map((admin, index) => (
            <div key={admin.username || admin.email || index} className="table-row three-columns">
              <span className="table-cell patient-name">
                {admin.full_name}
              </span>
              <span className="table-cell">{admin.email || 'N/A'}</span>
              <span className="table-cell">
                <button
                  className="action-button"
                  onClick={() => handleAdminClick(admin)}
                >
                  View
                </button>
              </span>
            </div>
          ))}

          {filteredAdmins.length === 0 && (
            <div className="no-data-row">
              <span className="no-data-message">
                {searchInput
                  ? "No Admins found matching your search."
                  : "No Admins available."}
              </span>
            </div>
          )}
        </div>

        <div className="table-footer">
          <span className="table-info">
            Showing {filteredAdmins.length} of {filteredCounts.total} Admins
          </span>
        </div>
      </div>
    </div>
  );
};

export default AdminList;
